import React from 'react'
import Layout from "../components/App/Layout"
import Navbar from "../components/App/Navbar"
import PageBanner from '../components/Common/PageBanner'
import Footer from "../components/App/Footer"
import ServiceDetailsContentmdm from '../components/ServiceDetailsmdm/ServiceDetailsContentmdm'
import RelatedServicesmdm from '../components/ServiceDetailsmdm/RelatedServicesmdm'

const Details = () => {
    return (
        <Layout>
            <Navbar />
            <PageBanner
                pageTitle="Mater Data Management  "
                homePageText="Home"
                homePageUrl="/"
                activePageText="Service Details"
            />
            <ServiceDetailsContentmdm />
            <RelatedServicesmdm />
            <Footer />
        </Layout>
    );
}

export default Details